import { FETCH_PREMIUM_BETS, FETCH_BETS_HISTORY} from "../actions/types";

const premiumBets =  (state = "loading", action) => {
  switch (action.type) {
    case FETCH_PREMIUM_BETS:
      if(!action.payload){
        return action.payload;
      }else if(state !== "loading" && state){
        return {...state, ...action.payload}
      }else return action.payload;
    default:
      return state;
  }
};


const betHistory =  (state = "loading", action) => {
  switch (action.type) {
    case FETCH_BETS_HISTORY:
      return action.payload ;
    default:
      return state;
  }
};


export default {
  premiumBets,
  betHistory
}



// WEBPACK FOOTER //
// ./src/reducers/betsReducer.js